<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Work Status Timesheet</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">
                    <div class="table-responsive" style="min-height: 400px;">
                      <table class="table table-bordered">
                        <thead>
                        <tr>
                          <th>Employee Name</th>
                          <th>Description</th>
                          <th>Hours</th>
                          <th>Location</th>
                          <th>Conveyance Bill</th>
                          <th>Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, i) in workStatusTimeSheet" :key="i">
                             <td>{{ item.employee_name }}</td>
                             <td>{{ item.description }}</td>
                             <td>{{ item.hours }}</td>
                             <td>{{ item.area_name }}</td>
                             <td class="text-right">{{ item.conveyance }}</td>
                             <td>{{ item.date }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="row justify-content-between">
                      <div class="col-md-6 col-12 ml-2 btn-margin">
                        <button
                            v-if="canShowApproveStatus || canShowApprove"
                            class="btn btn-sm btn-success"
                            :disabled="canShowApproveStatus || loading"
                            @click="!canShowApproveStatus && emit('handleMarkDoneSave', 'approved')"
                        >
                          <i :class="canShowApproveStatus ? 'fa fa-check' : 'fa fa-thumbs-up'"></i>
                          {{ canShowApproveStatus ? 'Approved' : 'Approve' }}
                        </button>
                      </div>
                    </div>

                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import { ref } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  workStatusTimeSheet: {
    type: Array,
    default: () => []
  },
  canShowApproveStatus: {
    type: Boolean,
    default:false,
  },
  canShowApprove: {
    type: Boolean,
    default:false,
  },
  loading: {
    type: Boolean,
    default:false,
  },
});
const $store = useStore();
const modalRef = ref(null);
const loader = ref(false);
const emit = defineEmits(['handleMarkDoneSave']);

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

</script>
